<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :title="$t('CargoMsg.Cargo_ChargeChange')"
    width="1300px"
    :before-close="close"
    class="app-main-inner"
  >
    <div style="padding-bottom: 10px">
      <el-button
        v-if="!editable"
        id="btnAdd1"
        type="primary"
        @click="editClickHandler"
      >{{ $t('CargoMsg.Cargo_Edit') }}
      </el-button>
      <el-button
        v-if="!editable"
        id="btnDelete1"
        @click="close"
      >{{ $t('CargoMsg.Cargo_DisableOpen') }}
      </el-button>
      <el-button
        v-if="editable"
        id="btnAdd1"
        type="primary"
        @click="commitClickHandler"
      >{{ $t('CargoMsg.Cargo_Submit') }}
      </el-button>
      <el-button
        v-if="editable"
        id="btnDelete1"
        @click="cancel"
      >{{ $t('CargoMsg.Cargo_Cancel') }}
      </el-button>
    </div>
    <div class="section grid-wrapper">
      <cargo-up-down-resize
        :show-down="tabSelling.visible"
        :show-up="tabCost.visible"
        class="app-main-inner section"
        :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
        :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
        style="height: 100%;max-height: 800px"
      >
        <!--      应收-->
        <template slot="up">
          <div class="operations" style=";padding-bottom: 5px">
            <div class="triggers">
              <div>
                <span style="">{{ $t('SeaExport.receivable') }}</span>
                <charge-currency-total-group
                  ref="arTotalGroup"
                  no="arTotalGroup"
                  :amount-to-currency="localCurrency"
                  :data-provider="arTotalGroup.dataProvider"
                  :data-field="config._isCalculateExcludingAmount ? 'amount' : 'excludingTaxAmount'"
                  rate-field="exchangeRate"
                  :is-gross-profit="true"
                  :show-controlled-profit="privilege.showControlledProfit"
                  :show-cost-controlled="privilege.isCostControlled"
                  type="ar"
                />
              </div>
              <cargo-button-group-slider no="top" align="right" style="flex:1; border: none">
                <div style="padding-bottom: 10px">
                  <!--抄录应付-->
                  <el-button
                    type="primary"
                    :disabled="!editable"
                    @click="copySellingHandler()"
                  >{{ $t('FinanceManage.charge_sp6') }}
                  </el-button>
                  <!--费用方案-->
                  <el-button
                    type="primary"
                    :disabled="!editable"
                    @click="chargeSchemeHandler()"
                  >{{ $t('FinanceManage.charge_sp7') }}
                  </el-button>
                  <!--新增费用-->
                  <el-button
                    id="btnAdd1"
                    :disabled="!editable"
                    type="primary"
                    @click="addCost()"
                  >{{ $t('FinanceManage.charge_add') }}
                  </el-button>
                  <!--费用删除-->
                  <el-button
                    id="btnDelete1"
                    :disabled="!editable"
                    type="danger"
                    @click="deleteCost()"
                  >{{ $t('FinanceManage.charge_delete') }}
                  </el-button>
                </div>
              </cargo-button-group-slider>
            </div>
            <div class="filters" />
          </div>
          <cargo-ag-grid
            ref="tabCostGrid"
            :grid-options="tabCost.grid.gridOptions"
            :column-defs="dynamicColumnDefsForCost"
            :grid-params.sync="tabCost.grid.gridParams"
            config-module="202304"
            :row-data="tabCost.grid.overseaCostDetails"
            style="flex-grow:1;"
            @gridReady="onCostGridReady"
          />
        </template>
        <!--      应付-->
        <template slot="down">
          <div class="operations" style="margin-top: 10px;padding-bottom: 5px">
            <div class="triggers">
              <div>
                <span>{{ $t('SeaExport.payable') }}</span>
                <charge-currency-total-group
                  ref="apTotalGroup"
                  no="apTotalGroup"
                  :amount-to-currency="localCurrency"
                  :data-provider="apTotalGroup.dataProvider"
                  :data-field="config._isCalculateExcludingAmount ? 'amount' : 'excludingTaxAmount'"
                  rate-field="convertRateRmb"
                  :is-gross-profit="true"
                  :show-controlled-profit="privilege.showControlledProfit"
                  :show-controlled="privilege.isControlled"
                  type="ap"
                />
              </div>
              <cargo-button-group-slider no="top" align="right" style="flex:1; border: none">
                <div>
                  <!--抄录应收-->
                  <el-button
                    no="charge_copyCost"
                    type="primary"
                    :disabled="!editable"
                    @click="copyCostHandler(true)"
                  >{{ $t('FinanceManage.charge_copyCost') }}
                  </el-button>
                  <el-button
                    id="btnAdd2"
                    :disabled="!editable"
                    type="primary"
                    @click="addSelling()"
                  >{{ $t('FinanceManage.charge_add') }}
                  </el-button>
                  <!-- 删除费用 -->
                  <el-button
                    id="btnDelete2"
                    :disabled="!editable"
                    type="danger"
                    @click="deleteSelling()"
                  >{{ $t('FinanceManage.charge_delete') }}
                  </el-button>
                </div>
              </cargo-button-group-slider>
            </div>
            <div class="filters" />
          </div>
          <cargo-ag-grid
            ref="tabSellingGrid"
            :grid-options="tabSelling.grid.gridOptions"
            :grid-params.sync="tabSelling.grid.gridParams"
            :column-defs="dynamicColumnDefsForSelling"
            config-module="202305"
            :row-data="tabSelling.grid.overseaSellingDetails"
            style="flex-grow:1;"
            @gridReady="onSellingGridReady"
          />
          <div class=" operations" style="margin-top: 10px">
            <div class="filters" />
            <div class="triggers">
              <div style="display: flex;flex-direction: column;width: 100%">
                <div style="display: flex;flex-direction: row;">

                  <div>
                    <span>{{ $t('CargoMsg.Cargo_Profit') }}</span>
                    <charge-currency-total-group
                      no="profit"
                      :amount-to-currency="localCurrency"
                      :data-field="config._isCalculateExcludingAmount ? 'amount' : 'excludingTaxAmount' "
                      rate-field="convertRateRmb"
                      :data-provider="revenueTotalGroup.dataProvider"
                      :is-gross-profit="true"
                      :show-controlled-profit="privilege.showControlledProfit"
                      :show-controlled="privilege.isControlled"
                      type="revenue"
                      :show-cost-controlled="privilege.isCostControlled"
                    />
                    <span v-if="config.showGrossProfit">{{ $t('CargoMsg.Cargo_GrossMargin') }}: </span>
                    <charge-gross-margin
                      v-if="config.showGrossProfit"
                      :data-field="config._isCalculateExcludingAmount ? 'amount' : 'excludingTaxAmount' "
                      :data-provider="revenueTotalGroup.dataProvider"
                    />
                  </div>
                  <div style="margin-left: 10px">
                    <el-checkbox
                      v-show="checkbox.chkInternal.visible"
                      id="chkInternal"
                      v-model="checkbox.chkInternal.selected"
                      :label="$t('CargoMsg.Cargo_ShowInternalCharges')"
                      @change="chkInternalChargeHandler($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </cargo-up-down-resize>
    </div>

    <charge-apply-dialog
      v-if="workFlowApplyDialog.visible"
      ref="workFlowApplyDialog"
      :visible.sync="workFlowApplyDialog.visible"
      :change-charge="workFlowApplyDialog.changeCharge"
      :title="$t('CargoMsg.Cargo_ApprovalProcessForChargeChange')"
      type="apply"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="closeAndRefresh"
    />

    <!-- 费用方案导入弹窗 todo -->
    <charge-scheme-batch-dialog
      :visible.sync="chargePlanDialog.visible"
      :lob="chargePlanDialog.lob"
      :is-sea="chargePlanDialog.isSea"
      :original-condition="chargePlanDialog.originalCondition"
      :charge-scheme-is-approved="chargePlanDialog.chargeSchemeIsApproved"
      :source="chargePlanDialog.source"
      :job="job"
      @selectedSchemeHandler="(schemeDetails) => { selectedSchemeHandler(schemeDetails) }"
    />
  </el-dialog>
</template>

<script>

import ChargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import ChargeGrossMargin from '@/components/Cargo/Act/chargeSummary/ChargeGrossMargin'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor'
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import { mergeChargesForProfitTotal } from '@/components/Cargo/Job/booking/tabs/chargeProfitTotal'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { Charge } from '@/class/model/act/Charge'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import chargeApplyDialog from '@/components/Cargo/Common/Wrokflow/chargeApplyDialog'
import DateUtils from '@/utils/dateUtils'
import { getLoading } from '@/utils/utilBaseElement'
import lodash from 'lodash'
import { getUuid, sortByMultiField } from '@/utils'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import * as ChargeUtilsForConstant from '@/class/cargo/model/utils/ChargeUtils'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { getObjectByCache } from '@/utils/basicDataCache'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import StrUtils from '@/utils/StrUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { cache } from '@/utils/cacheManager'
import { chargeItemCompatibleLanguage, multiply, sleep } from '@/utils/commonUtil'
import BigNumber from 'bignumber.js'
import { createChangeChargeBpm } from '@/api/clearing/changeChargeBpm'

export default {
  name: 'ChangeChargeWorkFlowDialog',
  components: {
    CargoAdvanceSelect,
    ChargeGrossMargin,
    ChargeCurrencyTotalGroup,
    cargoUpDownResize,
    CargoButtonGroupSlider,
    chargeApplyDialog,
    ChargeSchemeBatchDialog
  },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    job: { type: Object, required: true },
    params: { type: Object, required: true },
    config: { type: Object, required: true },
    privilege: { type: Object, required: true },
    officeList: { type: Array, default: () => [] }, // 结算公司
    showWhtTax: { type: Boolean, default: false }
  },
  data() {
    return {
      userId: 0,
      departmentId: 0,
      localCurrency: 'RMB',
      activeTabName: 'charge',
      editable: false,
      selectTypeNames: TYPE_NAMES,
      settleBranchId: 0, // 结算公司Id
      arSettlementUnitOptional: false,
      isSpecialExpenseEntryFunction: false,
      companyFactorySigns: [], // 工厂列表
      checkbox: {
        chkInternal: { // 内结费用
          visible: false,
          selected: true // 默认勾选
        }
      },
      arTotalGroup: {
        dataProvider: [],
        visible: false
      },
      apTotalGroup: {
        dataProvider: [],
        visible: false
      },
      revenueTotalGroup: {
        dataProvider: [],
        visible: false
      },
      tabCost: { // 应收
        visible: true,
        grid: {
          uuidPrefixRule: 'addTabCost__', // 临时新增的uuid规则
          deleteUuids: [],
          modifyUuids: [],
          selectedRow: null, // 当前选中行， 待处理
          gridApi: null,
          chooseUuidSet: new Set(),
          chooseUuid: '',
          gridOptions: {
            suppressRowClickSelection: true,
            suppressCopyRowsToClipboard: true,
            singleClickEdit: true,
            rowSelection: 'multiple',
            getRowStyle: (params) => {
              const chargeData = params.data
              const rowStyle = {}
              if (Object.prototype.hasOwnProperty.call(chargeData, 'controlled') && chargeData.controlled) {
                Object.assign(rowStyle, { 'font-weight': 'bold', 'color': '#800000' })
              }
              return rowStyle
            },
            frameworkComponents: {
              CargoAgGridAdvanceSelectEditor,
              CargoAgGridCommonInputEditor,
              CargoAgGridSelectEditor,
              CargoAgGridAdvanceMultipleSelectEditor,
              CargoAgGridCommonTextareaEditor
            }
          },
          gridParams: {},
          overseaCostDetailOlds: [],
          overseaCostDetails: []
        }
      },
      copyedChargeList: [],
      chooseSellingRows: [],
      copyCount: 0,
      tabSelling: { // 应付
        visible: true,
        grid: {
          uuidPrefixRule: 'addTabSelling__', // 临时新增的uuid规则-待测试
          deleteUuids: [],
          modifyUuids: [],
          selectedRow: null,
          gridApi: null,
          chooseUuidSet: new Set(),
          gridOptions: {
            suppressRowClickSelection: true,
            suppressCopyRowsToClipboard: true,
            rowSelection: 'multiple',
            singleClickEdit: true,
            frameworkComponents: {
              CargoAgGridAdvanceSelectEditor,
              CargoAgGridCommonInputEditor,
              CargoAgGridSelectEditor,
              CargoAgGridAdvanceMultipleSelectEditor,
              CargoAgGridCommonTextareaEditor
            },
            getRowStyle: (params) => {
              const chargeData = params.data
              const rowStyle = {}
              if (Object.prototype.hasOwnProperty.call(chargeData, 'controlled') && chargeData.controlled) {
                Object.assign(rowStyle, { 'font-weight': 'bold', 'color': '#800000' })
              }
              return rowStyle
            }
          },
          gridParams: {},
          overseaSellingDetailOlds: [],
          overseaSellingDetails: []
        }
      },
      deleteList: [],
      changeCharges: [],
      isAr: false,
      chargePlanDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        isSea: false,
        lob: 'SE',
        source: 'tabCharges',
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      workFlowApplyDialog: {
        visible: false,
        changeCharge: {}
      },
      lob: '',
      loading: false,
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        companyContactPersonMap: new Map(), // company对应的联系人map 缓存
        companyCmpIdxForCustomerMap: new Map(), // 结算单位
        chargeMeasureSet: new Set(), // 费用单位
        mblCargoDocSet: new Set(), // 关单号set
        hblCargoDocSet: new Set(), // 关单号set
        officeIdForDepartmentMap: new Map(),
        officeIdForClearDepartmentMap: new Map(), // 结算公司
        currencySet: new Set(),
        userAllSet: new Set(), // cache中取得全部用户集合
        containerNoAllSet: new Set(), // 全部箱号
        user4AuditorSet: new Set(), // 审核人数据集合
        paymentTermSet: new Set(),
        customerDefaultTitleMap: new Map(), // 委托单位和默认发票抬头
        customerTitlesMap: new Map(), // 委托单位和关联的发票抬头
        customerSettlementAgentMap: new Map(),
        // 结算对象关联的结算代理
        vinNoAllSet: new Set(), // 全部车架号
        chargeItemSet: new Set()
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    language() {
      return this.$store.getters.language === 'zh'
    },
    currentSettleBranchId() {
      return this.settleBranchId > 0 ? this.settleBranchId : this.$store.getters.currentOfficeId
    },
    dynamicColumnDefsForSelling() {
      const result = [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              staticOptions: [...this.currentViewCacheData.chargeItemSet],
              methodParams: this.getChargeItemFilter(false),
              tagValue: 'itemId',
              tagName: this.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        // {
        //   headerName: this.$t('ChangeCharge.changeReason'),
        //   editable: true,
        //   colId: 'changeReason',
        //   field: 'changeReason',
        //   cellEditor: 'CargoAgGridCommonTextareaEditor',
        //   onCellValueChanged: p => this.onCellChange(p)
        // },
        {
          headerName: this.$t('FinanceManage.charge_settleAccountsTo'),
          colId: 'accountId',
          field: 'accountId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true },
              autoKey: 'auto_0',
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                return true
                // return this.config.isInputChargeBaseOnService
              },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'invoiceTitle',
          field: 'invoiceTitle',
          initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'invoiceTitle',
              tagName: 'invoiceTitle',
              allowCreate: true,
              staticOptions: this.getInvoiceTitleList(params.data.accountId),
              filterable: true,
              filterTagNames: ['invoiceTitle'],
              filterType: 'global'
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.internal') }, { code: true, value: this.$t('SeaExport.overseas') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_drawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Payment.controlledOrNot'),
          colId: 'controlled',
          field: 'controlled',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && (this.privilege.isControlled),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currentViewCacheData.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DateType'),
          colId: 'dateType',
          field: 'dateType',
          initialWidth: 130,
          valueFormatter: (params) => {
            return params.value === 'BusinessDate' ? this.$t('Message.ByBusinessDate') : this.$t('Message.ByAdjustmentDate')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: 'AdjustmentDate', value: this.$t('Message.ByAdjustmentDate') }, { code: 'BusinessDate', value: this.$t('Message.ByBusinessDate') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'), colId: 'measure', field: 'measure', initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              methodParams: { unit: true, seaFreight: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          },
          editable: (params) => this.editable && !params.data.uuid,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE]
            return {
              selectProps: {
                tagValue: 'code',
                tagName: 'chineseName',
                staticOptions,
                filterable: true,
                filterTagNames: ['code', 'chineseName']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          colId: 'excludingTaxAmount1',
          field: 'excludingTaxAmount',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax',
          field: 'unitPriceIncludeTax',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && !!this.config.inputIncludingTaxUnitPrice,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }],
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          hide: !this.config.inputIncludingTaxUnitPrice,
          suppressColumnsToolPanel: !this.config.inputIncludingTaxUnitPrice
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        },
        {
          headerName: this.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_contactPerson'),
          colId: 'contactPerson',
          field: 'contactPerson',
          initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = this.currentViewCacheData.companyContactPersonMap.get(params.data.accountId)
            return {
              selectProps: {
                tagValue: 'contactPerson',
                tagName: 'contactPerson',
                staticOptions,
                filterable: true,
                filterTagNames: ['contactPerson']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: (params) => {
            const staticOptionsMbl = [...this.currentViewCacheData.mblCargoDocSet]
            const staticOptionsHbl = [...this.currentViewCacheData.hblCargoDocSet]
            const optionsMBLValue = {}
            const optionsHBLValue = {}
            if (staticOptionsMbl.length > 0) {
              optionsMBLValue.label = 'MBL No.'
              optionsMBLValue.options = staticOptionsMbl
              optionsMBLValue.filterable = true
            }
            if (staticOptionsHbl.length > 0) {
              optionsHBLValue.label = 'HBL No.'
              optionsHBLValue.options = staticOptionsHbl
              optionsHBLValue.filterable = true
            }
            return {
              isGroup: true,
              tagValue: 'chargeRelatedBLNo',
              tagName: 'chargeRelatedBLNo',
              options: [optionsMBLValue, optionsHBLValue]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...this.currentViewCacheData.containerNoAllSet]
            return {
              selectProps: {
                tagValue: 'containerNo',
                tagName: 'containerNo',
                staticOptions,
                filterable: true
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'), field: 'whtTaxRate', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: params => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'), field: 'whtTaxAmount', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.whtTaxAmountConversionRMBLabel(params.data)
          }
        })
      }
      return result
    },
    dynamicColumnDefsForCost() {
      const result = [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              staticOptions: [...this.currentViewCacheData.chargeItemSet],
              methodParams: this.getChargeItemFilter(true),
              tagValue: 'itemId',
              tagName: this.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        // {
        //   headerName: this.$t('ChangeCharge.changeReason'),
        //   editable: true,
        //   colId: 'changeReason',
        //   field: 'changeReason',
        //   cellEditor: 'CargoAgGridCommonTextareaEditor',
        //   onCellValueChanged: p => this.onCellChange(p)
        // },
        {
          headerName: this.$t('FinanceManage.charge_settleAccountsTo'),
          colId: 'accountId',
          field: 'accountId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => (
            this.arSettlementUnitOptional ? {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Company,
                tagValue: 'cmpIdx',
                tagName: 'chineseName',
                methodParams: { active: true },
                autoKey: 'auto_0',
                dataFilterFunction: (item, inputVal) => {
                  if (item.cmpIdx === inputVal) {
                    return true
                  }
                  return true
                },
                filterable: true,
                staticOptions: this.companyFactorySigns
              }
            } : {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Company,
                tagValue: 'cmpIdx',
                tagName: 'chineseName',
                methodParams: { active: true },
                autoKey: 'auto_0',
                dataFilterFunction: (item, inputVal) => {
                  if (item.cmpIdx === inputVal) {
                    return true
                  }
                  return true
                },
                filterable: true
              }
            }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'invoiceTitle',
          field: 'invoiceTitle',
          initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'invoiceTitle',
              tagName: 'invoiceTitle',
              allowCreate: !this.arSettlementUnitOptional,
              staticOptions: this.getInvoiceTitleList(params.data.accountId),
              filterable: true,
              filterTagNames: ['invoiceTitle'],
              filterType: 'global'
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.internal') }, { code: true, value: this.$t('SeaExport.overseas') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_drawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Payment.controlledOrNot'),
          colId: 'controlled',
          field: 'controlled',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && (this.privilege.isCostControlled),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currentViewCacheData.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DateType'),
          colId: 'dateType',
          field: 'dateType',
          initialWidth: 130,
          valueFormatter: (params) => {
            return params.value === 'BusinessDate' ? this.$t('Message.ByBusinessDate') : this.$t('Message.ByAdjustmentDate')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: 'AdjustmentDate', value: this.$t('Message.ByAdjustmentDate') }, { code: 'BusinessDate', value: this.$t('Message.ByBusinessDate') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'), colId: 'measure', field: 'measure', initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              methodParams: { unit: true, seaFreight: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          },
          editable: (params) => this.editable && !params.data.uuid,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE]
            return {
              selectProps: {
                tagValue: 'code',
                tagName: 'chineseName',
                staticOptions,
                filterable: true,
                filterTagNames: ['code', 'chineseName']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          colId: 'excludingTaxAmount1',
          field: 'excludingTaxAmount',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax',
          field: 'unitPriceIncludeTax',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && !!this.config.inputIncludingTaxUnitPrice,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }],
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          hide: !this.config.inputIncludingTaxUnitPrice,
          suppressColumnsToolPanel: !this.config.inputIncludingTaxUnitPrice
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        },
        {
          headerName: this.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_contactPerson'),
          colId: 'contactPerson',
          field: 'contactPerson',
          initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = this.currentViewCacheData.companyContactPersonMap.get(params.data.accountId)
            return {
              selectProps: {
                tagValue: 'contactPerson',
                tagName: 'contactPerson',
                staticOptions,
                filterable: true,
                filterTagNames: ['contactPerson']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: (params) => {
            const staticOptionsMbl = [...this.currentViewCacheData.mblCargoDocSet]
            const staticOptionsHbl = [...this.currentViewCacheData.hblCargoDocSet]
            const optionsMBLValue = {}
            const optionsHBLValue = {}
            if (staticOptionsMbl.length > 0) {
              optionsMBLValue.label = 'MBL No.'
              optionsMBLValue.options = staticOptionsMbl
              optionsMBLValue.filterable = true
            }
            if (staticOptionsHbl.length > 0) {
              optionsHBLValue.label = 'HBL No.'
              optionsHBLValue.options = staticOptionsHbl
              optionsHBLValue.filterable = true
            }
            return {
              isGroup: true,
              tagValue: 'chargeRelatedBLNo',
              tagName: 'chargeRelatedBLNo',
              options: [optionsMBLValue, optionsHBLValue]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...this.currentViewCacheData.containerNoAllSet]
            return {
              selectProps: {
                tagValue: 'containerNo',
                tagName: 'containerNo',
                staticOptions,
                filterable: true
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'), field: 'whtTaxRate', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: params => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'), field: 'whtTaxAmount', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.whtTaxAmountConversionRMBLabel(params.data)
          }
        })
      }
      return result
    }
  },
  created() {
    this.userId = this.$store.getters.userId
    this.departmentId = this.$store.getters.currentDeptId
  },
  methods: {
    async onShow(job, costCharges, sellingCharges) {
      this.clear()
      this.initCurrencySet()
      this.initChargeItemSet()
      this.setLocalCurrency()
      this.settleBranchId = this.params.settleBranchId
      this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
      this.companyFactorySigns = []
      if (this.arSettlementUnitOptional) {
        this.companyFactorySigns = await ChargeUtils.getCompanyFactorySign(job.customerId)
      }
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
      // 设置列表数据
      await this.enrichDateType(costCharges)
      await this.enrichDateType(sellingCharges)
      this.tabCost.grid.overseaCostDetailOlds = lodash.cloneDeep(costCharges)
      this.tabSelling.grid.overseaSellingDetailOlds = lodash.cloneDeep(sellingCharges)
      this.tabCost.grid.overseaCostDetails = lodash.cloneDeep(costCharges)
      this.tabSelling.grid.overseaSellingDetails = lodash.cloneDeep(sellingCharges)
      this.refDgChargeInfo()
      if (this.tabCost.grid.gridOptions.api) {
        this.tabCost.grid.gridOptions.api.refreshCells({ force: true })
      }
      if (this.tabSelling.grid.gridOptions.api) {
        this.tabSelling.grid.gridOptions.api.refreshCells({ force: true })
      }
    },
    async enrichDateType(charges) {
      for (const charge of charges) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
        const exchangeRateNow = await RateUtil.getForeignExchangeRateSafely(localCurrency, charge.currency, new Date(), charge.branchId)
        const exchangeRateJob = await RateUtil.getForeignExchangeRateSafely(localCurrency, charge.currency, ['SE', 'AE', 'RE'].includes(this.job.lob) ? this.job.etd : this.job.eta, charge.branchId)
        if (Number(exchangeRateNow) === Number(exchangeRateJob)) {
          charge.dateType = 'AdjustmentDate'
        } else if (Number(charge.exchangeRate) === Number(exchangeRateJob)) {
          charge.dateType = 'BusinessDate'
        } else {
          charge.dateType = 'AdjustmentDate'
        }
      }
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
    },
    clear() {
      // 设置列表数据
      this.tabCost.grid.overseaCostDetails = []
      this.tabSelling.grid.overseaSellingDetails = []
      this.deleteList = []
      this.editable = false
    },
    close() {
      this.clear()
      this.$emit('close')
    },
    // 费用项目过滤
    getChargeItemFilter(isAr) {
      let filter = {}
      switch (this.job.lob) {
        case 'SE':
          filter = { seaExport: true, active: true }
          break
        case 'SI':
          filter = { seaImport: true, active: true }
          break
        case 'AE':
          filter = { airExport: true, active: true }
          break
        case 'AI':
          filter = { airImport: true, active: true }
          break
        case 'RE':
        case 'RI':
          filter = { railwayExport: true, active: true }
          break
        default:
      }
      if (isAr) {
        if (!this.privilege.isControlled) {
          filter.controlled = false
        }
      } else {
        if (!this.privilege.isCostControlled) {
          filter.controlled = false
        }
      }
      const s = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
      if (s) {
        filter.specialExpenseMarker = false
      }
      return filter
    },
    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currentViewCacheData.currencySet = new Set(results)
      this.initCargoDocSet()
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.currentViewCacheData.chargeItemSet = new Set(results)
    },
    async initCargoDocSet() {
      const jobClass = new SeaExportJob(this.job)
      await jobClass.getCargoDoc()
      this.currentViewCacheData.mblCargoDocSet = new Set()
      this.currentViewCacheData.hblCargoDocSet = new Set()
      const j = this.job
      for (const seDoc of this.job.cargoDoc || []) {
        if (j.lob === 'SE' || j.lob === 'SI') {
          if (seDoc.docType === CargoDocConsts.MBL && j.signMBL) {
            if (!StrUtils.isEmpty(this.job.mbl)) {
              seDoc.chargeRelatedBLNo = this.job.mbl
              this.currentViewCacheData.mblCargoDocSet.add(seDoc)
            }
          } else if (seDoc.docType === CargoDocConsts.MBL2 && j.signMBL && j.typeMBL !== 1 && !seDoc.deleted) {
            if (!StrUtils.isEmpty(seDoc.mblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.mblNbr2
              this.currentViewCacheData.mblCargoDocSet.add(seDoc)
            }
          } else if ((seDoc.docType === CargoDocConsts.HBL || (seDoc.docType === CargoDocConsts.HBL2 && j.typeHBL !== 1)) && !seDoc.deleted && j.signHBL && !j.masterFlag) {
            if (!StrUtils.isEmpty(seDoc.hblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.hblNbr2
              this.currentViewCacheData.hblCargoDocSet.add(seDoc)
            }
          }
        }
      }
      this.getAllContainerNoHandler()
    },
    getAllContainerNoHandler() {
      if (this.job.containers) {
        this.currentViewCacheData.containerNoAllSet = new Set()
        for (const c of this.job.containers) {
          if (c.containerNo) {
            const cData = {}
            cData['containerNo'] = c.containerNo
            this.currentViewCacheData.containerNoAllSet.add(cData)
          }
        }
      }
    },
    onCostGridReady(params) {
      this.tabCost.grid.gridApi = params.api
    },
    onSellingGridReady(params) {
      this.tabSelling.grid.gridApi = params.api
    },
    // tab 页签点击事件
    handleClick(tab, event) {
      this.activeTabName = tab.name
    },
    async onCellChange(params) {
      console.log('cellChange', params)
      let firstAccountId = false
      if (!params.oldValue) {
        firstAccountId = true
      }
      const newParams = {
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        firstAccountId: firstAccountId,
        originalValue: params.oldValue
      }
      await this.chargeGridItemEditEndHandler(newParams)
    },
    async chargeGridItemEditEndHandler(params) {
      console.log('cellChange', params)
      const job = this.job
      const charge = params.data
      const oldInvoceTitle = charge.invoiceTitle
      const oldChargeItemId = charge.chargeItemId
      const oldWhtTaxRate = charge.whtTaxRate
      const oldExcludingTaxAmount = charge.excludingTaxAmount
      await ChargeColumnUtil.changeChargeCellChangeHandler(params, job, this.currentViewCacheData, this.config.inputIncludingTaxUnitPrice, this.config.currencyChangeBySettlementAccount)
      // 加载开票抬头
      await this.getTitlesByCompanyId(charge)
      if (charge.invoiceTitle) {
        if (params.field === 'invoiceTitle' || charge.invoiceTitle !== oldInvoceTitle) {
          const flag = ChargeUtils.updateOverseaByInvoiceTitle(charge, this.getInvoiceTitleList(charge.accountId))
          if (!flag && charge.invoiceTitle !== oldInvoceTitle && charge.accountId > 0 && params.field === 'accountId') {
            await ChargeUtils.updateOverseaByAccountId(charge)
          }
        }
      } else if (charge.accountId > 0) {
        if (params.field === 'accountId') {
          await ChargeUtils.updateOverseaByAccountId(charge)
        }
      }
      const office = this.$store.getters.currentOffice
      if (!charge.whtTaxRate && office.whtTaxMode && charge.invoiceTitle && charge.chargeItemId && (charge.invoiceTitle !== oldInvoceTitle || params.field === 'invoiceTitle' ||
        charge.chargeItemId !== oldChargeItemId || params.field === 'chargeItemId')) {
        const invoiceTitleList = this.getInvoiceTitleList(charge.accountId)
        if (invoiceTitleList) {
          const invoiceTitle = invoiceTitleList.find(p => p.title === charge.invoiceTitle)
          if (invoiceTitle && invoiceTitle.suitWhtTax) {
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
            if (chargeItem && chargeItem.defaultWhtRate > 0) {
              charge.whtTaxRate = chargeItem.defaultWhtRate
            }
          }
        }
      }
      if (charge.whtTaxRate !== oldWhtTaxRate || params.field === 'whtTaxRate' || charge.excludingTaxAmount !== oldExcludingTaxAmount) {
        if (charge.whtTaxRate > 0 && charge.excludingTaxAmount > 0) {
          charge.whtTaxAmount = NumberUtils.ToFixed2(charge.excludingTaxAmount * charge.whtTaxRate / 100, 2)
        } else {
          charge.whtTaxAmount = 0
        }
      }
      if (charge.receivable) {
        this.tabCost.grid.gridOptions.api.refreshCells({ force: true })
      } else {
        this.tabSelling.grid.gridOptions.api.refreshCells({ force: true })
      }
      this.refDgChargeInfo()
    },
    async editClickHandler() {
      this.editable = true
    },
    async addCost() {
      this.addCharge(true)
    },
    async deleteCost() {
      const api = this.tabCost.grid.gridOptions.api
      const rows = api.getSelectedRows()
      for (const data of rows) {
        if (data.uuid && !(data.uuid.startsWith(this.tabCost.grid.uuidPrefixRule) || data.uuid.startsWith(this.tabSelling.grid.uuidPrefixRule))) {
          data.actionType = 2
          this.deleteList.push(data)
        }
      }
      api.updateRowData({ remove: rows })
      const rowData = []
      api.forEachNode(node => rowData.push(node.data))
      this.tabCost.grid.overseaCostDetails = rowData
      this.tabCost.grid.gridOptions.api.refreshCells({ force: true })
      this.refDgChargeInfo()
    },
    async addSelling() {
      await this.addCharge(false)
    },
    async addCharge(isAr) {
      const item = new Charge().fillDefaultValue().getData()
      // const officeId = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.getBranchIdForCharge())
      item.localCurrency = localCurrency
      item.currency = localCurrency
      item.jobUuid = this.job.uuid
      item.businessDate = this.job.businessDate
      item.inputBy = this.userId
      item.inputDate = new Date()
      item.auditDate = new Date()
      item.inputByDep = this.departmentId
      item.branchId = this.currentSettleBranchId
      item.receivable = isAr
      item.verifiedAmount = 0
      item.adjustment = true
      item.offsetState = 0
      item.chargeState = 0
      item.measure = 'NML'
      const office = this.$store.getters.currentOffice
      if (office && String(office.taxRate) !== 'NaN') {
        item.taxRate = office.taxRate
      } else {
        item.taxRate = 0
      }
      item.taxRate = ChargeUtils.getTaxRateAtCreateCharge(item)
      item.unitPriceIncludeTax = this.config.inputIncludingTaxUnitPrice === 2
      if (isAr) {
        this.tabCost.grid.overseaCostDetails.push(item)
        this.tabCost.grid.gridOptions.api.refreshCells({ force: true })
      } else {
        this.tabSelling.grid.overseaSellingDetails.push(item)
        this.tabSelling.grid.gridOptions.api.refreshCells({ force: true })
      }
      item.dateType = 'AdjustmentDate'
    },
    async getTitlesByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      if (this.currentViewCacheData.customerTitlesMap.has(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId)
      }
      // 获取数据库中维护的开票抬头
      const res = await queryTitleByCpmIdx(accountId)
      let dbTitles = res.data
      if (!dbTitles) dbTitles = []
      if (dbTitles.length > 0) {
        for (const title of dbTitles) {
          if (!title.title) continue
          title.invoiceTitle = title.title
        }
      }
      this.currentViewCacheData.customerTitlesMap.set(accountId, dbTitles)
      return this.currentViewCacheData.customerTitlesMap.get(accountId)
    },
    async deleteSelling() {
      const api = this.tabSelling.grid.gridOptions.api
      const rows = api.getSelectedRows()
      for (const data of rows) {
        if (data.uuid && !(data.uuid.startsWith(this.tabCost.grid.uuidPrefixRule) || data.uuid.startsWith(this.tabSelling.grid.uuidPrefixRule))) {
          data.actionType = 2
          this.deleteList.push(data)
        }
      }
      api.updateRowData({ remove: rows })
      const rowData = []
      api.forEachNode(node => rowData.push(node.data))
      this.tabSelling.grid.overseaSellingDetails = rowData
      this.tabSelling.grid.gridOptions.api.refreshCells({ force: true })
      this.refDgChargeInfo()
    },
    async onSettleBranchIdHandler() {

    },
    async chkInternalChargeHandler() {

    },
    cancel() {
      this.editable = false
      this.clear()
      this.initCurrencySet()
      // 设置列表数据
      this.tabCost.grid.overseaCostDetails = lodash.cloneDeep(this.tabCost.grid.overseaCostDetailOlds)
      this.tabSelling.grid.overseaSellingDetails = lodash.cloneDeep(this.tabSelling.grid.overseaSellingDetailOlds)
      if (this.tabCost.grid.gridOptions.api) {
        this.tabCost.grid.gridOptions.api.refreshCells({ force: true })
      }
      if (this.tabSelling.grid.gridOptions.api) {
        this.tabSelling.grid.gridOptions.api.refreshCells({ force: true })
      }
    },
    async processCharges(tabGrid, charges) {
      for (const item of tabGrid) {
        if (!this.validateCharge(item)) {
          return false
        }
        item.serialNumber = this.refreshSerialNumber(item.isAr, this.job.charges)
        if (item.uuid.startsWith(this.tabCost.grid.uuidPrefixRule) || item.uuid.startsWith(this.tabSelling.grid.uuidPrefixRule)) {
          item.uuid = ''
        }
        charges.push(item)
      }
      return true
    },
    checkField(list1, list2) {
      const stringFields = ['contactPerson', 'currency', 'oversea', 'needInvoice', 'measure', 'unitPriceIncludeTax', 'invoiceTitle', 'remarks', 'controlled', 'relatedMbl', 'relationContainerNo']
      const fields = ['chargeItemId', 'accountId', 'branchId', 'exchangeRate', 'quantity', 'unitRate', 'amount', 'excludingTaxAmount', 'taxRate', 'taxAmount', 'whtTaxRate', 'whtTaxAmount']
      for (const data of list2) {
        if (data.uuid && !(data.uuid.startsWith(this.tabCost.grid.uuidPrefixRule) || data.uuid.startsWith(this.tabSelling.grid.uuidPrefixRule))) {
          let update = fields.some(field => ColumnUtils.checkFieldUpdate(list1, list2, {
            colDef: { field },
            uuid: data.uuid
          }, true))
          if (!update) {
            update = stringFields.some(field => ColumnUtils.checkFieldUpdate(list1, list2, {
              colDef: { field },
              uuid: data.uuid
            }, false))
          }
          if (update) {
            data.actionType = 0
          } else {
            data.actionType = -1
          }
        } else {
          data.actionType = 1
        }
      }
    },
    commitClickHandler() {
      this.$confirm('<p>' + this.$t('CargoMsg.Cargo_ChargeChangeTip2') + '</p><p>' + this.$t('CargoMsg.Cargo_ChargeChangeTip3') + '</p>', this.$t('common.tips.prompt'),
        {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }
      ).then(async() => {
        const charges = []
        this.checkField(this.tabCost.grid.overseaCostDetailOlds, this.tabCost.grid.overseaCostDetails)
        this.checkField(this.tabSelling.grid.overseaSellingDetailOlds, this.tabSelling.grid.overseaSellingDetails)
        if (!await ChargeUtils.checkUnitRate([...this.tabCost.grid.overseaCostDetails, ...this.tabSelling.grid.overseaSellingDetails], this)) {
          return false
        }
        if (await this.processCharges(this.tabCost.grid.overseaCostDetails, charges) &&
          await this.processCharges(this.tabSelling.grid.overseaSellingDetails, charges)) {
          const tips = charges.some(charge => charge.actionType > -1)
          if (!tips && (!this.deleteList || this.deleteList.length === 0)) {
            this.$message.warning('没有数据发生修改.')
            return false
          }
          this.loading = getLoading()
          // 1、保存【费用更改】
          try {
            const changeChargeVo = {
              // 审批流匹配始终以当前分公司为准（不管协作公司选的是啥）
              branchId: this.params.settleBranchId,
              jobUuid: this.job.uuid, // 这里传业务uuid
              chargeVOS: [...charges, ...this.deleteList],
              jobNo: this.job.jobNo,
              lob: this.job.lob
            }
            const changeCharge = await createChangeChargeBpm(changeChargeVo).then(res => res.data)

            if (changeCharge) {
              // // 2、审批流check
              // const params = {
              //   docId: changeCharge.uuid, // 这里申请单uuid
              //   documentConfigId: CHARGE_CHANGE.code,
              //   officeId: this.job.opOffice
              // }
              // await workflowCheck(params).then(async res => {
              //   if (res.data && res.data.skipApprove) {
              //     // 跳过审批
              //     this.$emit('returnCall')
              //     return
              //   }

              // // 3、发起【费用更改审批】
              // if (res.data && res.data.actions && res.data.actions.length > 0) {
              // const commitActions = res.data.actions.filter(btn => btn.actionType === 7000)
              // // 提交 bpm
              // if (commitActions.length > 0) {
              //   // this.loading = getLoading()
              //   const commitParams = {
              //     documentConfigId: CHARGE_CHANGE.code,
              //     docId: this.job.uuid,
              //     docNo: this.job.jobNo,
              //     actionId: commitActions[0].id,
              //     actionType: commitActions[0].actionType,
              //     officeId: this.job.opOffice,
              //     applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code
              //   }
              //   await workflowAction(commitParams).then(res => {
              //     this.$message.success(commitActions[0].actionName + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
              //   }).catch(reason => {
              //   })
              // }
              changeCharge.companyChineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', this.$store.getters.currentOfficeId, 'chineseName')
              changeCharge.inputDepartmentChineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', this.$store.getters.currentDeptId, 'chineseName')
              changeCharge.chineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.$store.getters.userId, 'chineseName')
              changeCharge.inputDateStr = DateUtils.formatStandardDate(new Date())
              this.workFlowApplyDialog.changeCharge = changeCharge
              this.workFlowApplyDialog.visible = true
              //   }
              // })
            }
          } finally {
            this.loading.close()
          }
        }
      }).catch(() => {
      })
    },
    async closeAndRefresh() {
      this.workFlowApplyDialog.visible = false
      this.$emit('close')
      this.$emit('returnCall')
    },
    refreshSerialNumber(isAr, charges) {
      let number = 0
      if (!charges) return number
      for (const c of charges) {
        if (c.receivable === isAr) {
          number++
        }
      }
      return number
    },
    // 保存费用校验
    validateCharge(charge) {
      if (isNaN(charge['accountId']) || Number(charge['accountId']) <= 0) {
        this.$message.warning(this.$t('Message.SettlementPartyCannotBeNull'))
        return false
      }
      if (isNaN(charge['chargeItemId']) || Number(charge['chargeItemId']) <= 0) {
        this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
        return false
      }
      if (isNaN(charge['quantity']) || Number(charge['quantity']) === 0) {
        this.$message.warning(this.$t('Message.AmountCannotBeZero'))
        return false
      }
      if (isNaN(charge['exchangeRate']) || Number(charge['exchangeRate']) === 0) {
        this.$message.warning(this.$t('Message.ExchangeCannotBeZero2'))
        return false
      }
      if (charge['remarks'] && charge['remarks'].length > 50) {
        this.$message.warning(this.$t('Message.RemarkTheLengthCannotExceed'))
        return false
      }
      // if (!charge.changeReason) {
      //   this.$message.warning(this.$t('ChangeCharge.changeReasonCannotBeNull'))
      //   return false
      // }
      // if (charge.changeReason.length > 100) {
      //   this.$message.warning(this.$t('ChangeCharge.changeReasonIsTooLong'))
      //   return false
      // }
      return true
    },
    refDgChargeInfo() {
      this.arTotalGroup.dataProvider = this.getTotalCharges(0)
      this.apTotalGroup.dataProvider = this.getTotalCharges(1)
      this.revenueTotalGroup.dataProvider = this.getTotalCharges(-1)
    },
    /**
     * 获取总的应收应付金额（利润/毛利率口径：剔除商务特殊费用，见 chargeProfitTotal）
     */
    getTotalCharges(ar) {
      const arCharges = (ar === 0 || ar === -1) ? this.tabCost.grid.overseaCostDetails : []
      const apCharges = (ar === 1 || ar === -1) ? this.tabSelling.grid.overseaSellingDetails : []
      return mergeChargesForProfitTotal(arCharges, apCharges)
    },
    // 费用方案
    async chargeSchemeHandler() {
      if (!this.job) {
        this.$message.info(this.$t('Message.TheCurrentlyRelevantBusinessInformationIsNull'))
        return
      }
      const job = this.job
      this.chargePlanDialog.isSea = job.lob === 'SE' || job.lob === 'SI'
      this.chargePlanDialog.lob = job.lob
      this.chargePlanDialog.chargeSchemeIsApproved = this.config.chargeSchemeIsApproved // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.chargePlanDialog.visible = true
    },
    // 费用方案 -选择费用后事件
    async selectedSchemeHandler(schemeDetails) {
      if (!schemeDetails || schemeDetails.length <= 0) return
      if (this.config.accountObjectControlMode) {
        for (const schemeDetail of schemeDetails) {
          if (schemeDetail.receivable && !this.config.arSettlementUnitOptional) {
            schemeDetail.accountId = this.job.customerId
          }
        }
      }
      const chargeBranchId = this.privilege.showOtherBranchCharge ? this.currentSettleBranchId : this.getBranchIdForCharge()
      const charges = await ChargeUtils.applyChargeScheme(this.job, schemeDetails, 0, this.config._getHBLcWeight, chargeBranchId)
      for (const charge of charges) {
        if (this.config.openHecConfig) {
          charge.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
        }
        if (this.config.currentOfficeCharge && this.job.salesOffice) {
          charge.branchId = this.job.salesOffice
        }
        if (charge.accountId && charge.accountId > 0) {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
          // CARGO-36892,合作伙伴无效时置为0
          if (!company.active) {
            charge.accountId = 0
          }
        }
        if (this.config.arSettlementUnitOptional && charge.receivable && !ChargeUtils.checkFactorySign(this.companyFactorySigns, charge.accountId)) {
          charge.accountId = 0
          charge.invoiceTitle = ''
        }
      }
      if (this.privilege.showOtherBranchCharge && charges && charges.length > 0) charges.forEach(charge => { charge.branchId = this.currentSettleBranchId })
      // CARGO-1072，默认开票抬头：通过费用方案
      await ChargeUtils.updateDefaultInvoiceTitle(charges)
      // 是否有禁用的收费项目标识
      let haveDisableItem = false
      if (charges && charges.length > 0) {
        const accountTitleMap = new Map()
        this.$logger.log('费用方案--changeCharge', charges)
        for (const charge of charges) {
          // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
          if (!chargeItem || !chargeItem.active) {
            haveDisableItem = true
            continue
          }
          if (this.isSpecialExpenseEntryFunction) {
            if (chargeItem && chargeItem.specialExpenseMarker) {
              charge.chargeItemId = 0
            }
          }
          if (charge.accountId && charge.accountId > 0) {
            await this.getSettlementByCompanyId(charge)
            // CARGO-35852 通过费用方案生成费用，没有按照开票要求里选的国内国外，生成费用的国内国外（有备注）
            const canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))
            if (canChangeOverseaOfCharge !== 2 && canChangeOverseaOfCharge !== 3) {
              if (charge.invoiceTitle) {
                let invoiceTitleList = null
                if (accountTitleMap.has(charge.accountId)) {
                  invoiceTitleList = accountTitleMap.get(charge.accountId)
                } else {
                  invoiceTitleList = await ChargeUtils.getTitleListByCompanyCmpIdx(charge.accountId)
                  accountTitleMap.set(charge.accountId, invoiceTitleList)
                }
                const flag = ChargeUtils.updateOverseaByInvoiceTitle(charge, invoiceTitleList)
                if (!flag) { // 费用的开票抬头不在结算对象维护的开票抬头中时，根据结算对象带出默认的国内国外
                  await ChargeUtils.updateOverseaByAccountId(charge)
                }
              } else if (charge.accountId > 0) {
                await ChargeUtils.updateOverseaByAccountId(charge)
              }
            }
          }
          await this.loadChargeWht(charge)
          if (charge.receivable) {
            this.tabCost.grid.overseaCostDetails.push(charge)
            this.tabCost.grid.gridOptions.api.refreshCells({ force: true })
          } else {
            this.tabSelling.grid.overseaSellingDetails.push(charge)
            this.tabSelling.grid.gridOptions.api.refreshCells({ force: true })
          }
        }
        // 抄录的有禁用的收费项目提示
        if (haveDisableItem) {
          this.$message.warning(this.$t('Message.Some_Items_Have_Expired'))
          await sleep(100)
        }
      }
    },
    // 抄录应收
    async copyCostHandler() {
      // CARGO-28543 勾选抄录时，相同费用名称也可抄录
      const chooseCostRows = this.tabCost.grid.gridApi.getSelectedRows()
      if (chooseCostRows.length !== 0) {
        // CARGO-2399，抄录应付/应收：只抄录普通费用
        this.chooseCostRows = chooseCostRows.filter(charge => !(this.privilege.enableCommission && charge.special))
        if (this.chooseCostRows.length === 0) {
          this.$message.info(this.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems1') + ' ' + 0 + ' ' + this.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
          return
        }
        for (const charge of this.chooseCostRows) {
          if (!this.checkChargeItemId(charge, false)) {
            // 存在重复的，则弹窗让用户确认
            this.$confirm(this.$t('Tool.RepeatCopyMessage'), this.$t('CargoMsg.Cargo_ConfirmR')).then(() => {
              this.copyChooseCostHandler()
            }).catch(() => {})
            return
          }
        }
        this.copyChooseCostHandler()
        return
      }
      // 抄录所有时，相同费用名称不可抄录
      const costCharges = this.tabCost.grid.overseaCostDetails
      const overseaSellingDetails = this.tabSelling.grid.overseaSellingDetails
      if (costCharges === null || costCharges.length === 0) {
        this.$message.info(this.$t('Message.ReceivalbeIsNull'))
        return
      }
      this.copyCount = 0
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.getBranchIdForCharge())
      this.copyedChargeList = []
      for (const charge of costCharges) {
        // CARGO-2399，抄录应付/应收：只抄录普通费用
        if (this.privilege.enableCommission && charge.special) {
          continue
        }
        if (this.checkChargeItemId(charge, false)) {
          await this.realCopyCostHandler(charge, localCurrency, overseaSellingDetails)
        }
      }
      if (this.copyCount > 0) {
        this.$message.info(this.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems1') + ' ' + this.copyCount + ' ' + this.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
      } else {
        this.$message.info(this.$t('Message.NoReceivablesCanBeCopiedThereMayBeSameChargeItems'))
      }
      await this.refreshCopyedChargeTitle()
      // 按费用序号排序【需要升序】
      this.tabSelling.grid.overseaSellingDetails = sortByMultiField(overseaSellingDetails, ['serialNumber'], false)
      this.refDgChargeInfo()
    },
    // 抄录费用-选择费用后返回事件
    async selectedCopyChargeHandler(chargeList) {
      const costCharges = chargeList
      let i = 0
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.getBranchIdForCharge())
      this.copyedChargeList = []
      // 是否有禁用的收费项目标识
      let haveDisableItem = false
      for (const charge of costCharges) {
        const obj = new Charge().fillDefaultValue().getData()
        obj.uuid = ''
        obj.jobUuid = this.job.uuid
        // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (!chargeItem || !chargeItem.active) {
          haveDisableItem = true
          continue
        }
        obj.chargeItemId = charge.chargeItemId
        obj.unitPriceIncludeTax = charge.unitPriceIncludeTax
        obj.accountId = this.config.accountObjectControlMode && charge.receivable ? this.job.customerId : charge.accountId
        if (obj.accountId && obj.accountId > 0) {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', obj.accountId)
          // CARGO-36892,合作伙伴无效时置为0
          if (!company || !company.active) {
            obj.accountId = 0
          }
        }
        if (obj.accountId && obj.accountId > 0) {
          await this.getSettlementByCompanyId(obj)
        }
        obj.inputBy = this.$store.getters.userId
        obj.inputDate = DateUtils.formatStandardDateTime(new Date())
        obj.oversea = charge.oversea
        obj.currency = charge.currency
        obj.measure = charge.measure
        if (parseInt(cache.config.get('openHecConfig')) === 1) {
          obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
        }
        obj.receivable = charge.receivable
        obj.unitRate = charge.unitRate
        obj.taxRate = charge.taxRate
        obj.quantity = charge.quantity
        if (obj.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(obj, multiply(obj.quantity, obj.unitRate), obj.taxRate)
        } else {
          ChargeUtils.calculateTax(obj, multiply(obj.quantity, obj.unitRate), obj.taxRate)
        }
        obj.verifiedAmount = 0
        obj.accountingDate = null
        obj.counterPartyBillingNo = null
        // 序号，CARGO-5881，按照录入顺序排序
        // 后端的  syncBranchId 在前端此处赋值即可
        obj.branchId = this.privilege.showOtherBranchCharge ? this.currentSettleBranchId : this.getBranchIdForCharge()
        obj.inputByDep = this.job.opDepartment
        obj.businessDate = this.job.businessDate
        obj.localCurrency = localCurrency
        obj.dateType = 'AdjustmentDate'
        obj.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, this.job, obj.branchId)
        // this.fillDefaultCopyValueByCharge(obj, charge, this.job, false)
        // await ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
        await ChargeUtils.updateDefaultInvoiceTitle([obj])
        i++
        this.copyedChargeList.push(obj)
        if (this.copyChargeDialog.receivable) {
          this.tabCost.grid.overseaCostDetails.push(obj)
        } else {
          this.tabSelling.grid.overseaSellingDetails.push(obj)
        }
      }
      // 抄录的有禁用的收费项目提示
      if (haveDisableItem) {
        this.$message.warning(this.$t('Message.Some_Items_Have_Expired'))
        await sleep(100)
      }
      if (i > 0) {
        this.copyChargeDialog.visible = false
        this.$message.info(this.$t('Message.CopyChargeSuccessfullyTotallyOfNItems1') + ' ' + i + ' ' + this.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
      } else {
        this.$message.info(this.$t('Message.NoChargeCanBeCopiedThereMayBeSameChargeItems'))
        return
      }
      await this.refreshCopyedChargeTitle()
      if (this.copyedChargeList != null && this.copyedChargeList.length > 0) {
        for (const charge of this.copyedChargeList) {
          await this.loadChargeWht(charge)
        }
      }

      this.refDgChargeInfo()

      // let arCount = 0
      // let apCount = 0
      // const arData = []
      // const apData = []
      // for (const item of this.rowData) {
      //   if (item.receivable) {
      //     arCount = arCount + 1
      //     arData.push(item)
      //   } else {
      //     apCount = apCount + 1
      //     apData.push(item)
      //   }
      // }
      // this.totalCurrencyCharge.arData = arData
      // this.totalCurrencyCharge.apData = apData
      // this.totalCurrencyCharge.arCount = arCount
      // this.totalCurrencyCharge.apCount = apCount
    },
    // 带出费用WHT税率和税额
    async loadChargeWht(charge) {
      const office = this.$store.getters.currentOffice
      charge.whtTaxAmount = 0
      if (office.whtTaxMode && charge.invoiceTitle && charge.chargeItemId) {
        const invoiceTitleList = await this.getTitlesByCompanyId(charge)
        if (invoiceTitleList) {
          const invoiceTitle = invoiceTitleList.find(p => p.title === charge.invoiceTitle)
          if (invoiceTitle && invoiceTitle.suitWhtTax) {
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
            if (chargeItem && chargeItem.defaultWhtRate > 0) {
              charge.whtTaxRate = chargeItem.defaultWhtRate
              if (charge.whtTaxRate > 0 && charge.excludingTaxAmount > 0) {
                charge.whtTaxAmount = NumberUtils.ToFixed2(charge.excludingTaxAmount * charge.whtTaxRate / 100, 2)
              }
            }
          }
        }
      }
    },
    whtTaxAmountConversionRMBLabel(charge) {
      if (charge) {
        const whtTaxAmount = new BigNumber(charge.whtTaxAmount)
        const exchangeRate = new BigNumber(charge.exchangeRate)
        const num = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(whtTaxAmount, exchangeRate), charge.localCurrency), 2)
        charge.whtTaxLocalAmount = num
        return this.$numeral(num).format('0.00')
      }
      return '0.00'
    },
    async copyChooseCostHandler() {
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.getBranchIdForCharge())
      const overseaSellingDetails = this.tabSelling.grid.overseaSellingDetails
      for (const charge of this.chooseCostRows) {
        await this.realCopyCostHandler(charge, localCurrency, overseaSellingDetails)
      }
      this.$message.info(this.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems1') + ' ' + this.chooseCostRows.length + ' ' + this.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
      await this.refreshCopyedChargeTitle()
      // 按费用序号排序【需要升序】
      this.tabSelling.grid.overseaSellingDetails = sortByMultiField(overseaSellingDetails, ['serialNumber'], false)
      this.refDgChargeInfo()
    },
    async realCopyCostHandler(charge, localCurrency, overseaSellingDetails) {
      const obj = new Charge().fillDefaultValue().getData()
      obj.uuid = this.tabSelling.grid.uuidPrefixRule + getUuid()
      obj.jobUuid = this.job.uuid
      obj.chargeItemId = charge.chargeItemId
      if (this.isSpecialExpenseEntryFunction) {
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (chargeItem && chargeItem.specialExpenseMarker) {
          obj.chargeItemId = 0
        }
      }
      obj.accountId = this.job.customerId
      obj.inputBy = this.$store.getters.userId
      obj.inputDate = DateUtils.formatStandardDateTime(new Date())
      obj.currency = charge.currency
      obj.measure = charge.measure
      obj.receivable = false
      obj.quantity = charge.quantity
      obj.localCurrency = localCurrency
      obj.unitRate = charge.unitRate
      obj.amount = charge.amount
      obj.taxRate = charge.taxRate
      obj.taxAmount = charge.taxAmount
      if (this.config.openHecConfig) {
        obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
      }
      obj.excludingTaxAmount = charge.excludingTaxAmount
      obj.verifiedAmount = 0
      obj.accountingDate = null
      obj.counterPartyBillingNo = null
      obj.serialNumber = this.getMaxSerialNumber(obj.receivable) + 1 // 序号，CARGO-5881，按照录入顺序排序
      // 后端的  syncBranchId 在前端此处赋值即可
      obj.branchId = this.privilege.showOtherBranchCharge ? this.currentSettleBranchId : this.job.opOffice
      obj.inputByDep = this.job.opDepartment
      obj.businessDate = this.job.businessDate
      obj.estimation = charge.estimation
      if (obj.estimation) {
        obj.estimationAmount = obj.amount
      }
      this.fillDefaultCopyValueByCharge(obj, charge, this.job, false)
      ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
      if (obj.accountId && obj.accountId > 0) {
        await this.getSettlementByCompanyId(obj)
      }
      obj.chargeSource = this.chargeSource
      this.copyCount++
      this.copyedChargeList.push(obj)
      this.tabSelling.grid.overseaSellingDetails.push(obj)
    },
    // 抄录应付
    async copySellingHandler() {
      // CARGO-28543 勾选抄录时，相同费用名称也可抄录
      const chooseSellingRows = this.tabSelling.grid.gridApi.getSelectedRows()
      if (chooseSellingRows.length !== 0) {
        // CARGO-2399，抄录应付/应收：只抄录普通费用
        this.chooseSellingRows = chooseSellingRows.filter(charge => !(this.privilege.enableCommission && charge.special))
        if (this.chooseSellingRows.length === 0) {
          this.$message.info(this.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems1') + ' ' + 0 + ' ' + this.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems2'))
          return
        }
        for (const charge of this.chooseSellingRows) {
          if (!this.checkChargeItemId(charge, true)) {
            // 存在重复的，则弹窗让用户确认
            this.$confirm(this.$t('Tool.RepeatCopyMessage'), this.$t('CargoMsg.Cargo_ConfirmR')).then(() => {
              this.copyChooseSellingHandler()
            }).catch(() => {})
            return
          }
        }
        this.copyChooseSellingHandler()
        return
      }
      // 抄录所有时，相同费用名称不可抄录
      const sellings = this.tabSelling.grid.overseaSellingDetails
      const overseaCostDetails = this.tabCost.grid.overseaCostDetails
      if (!sellings || sellings.length === 0) {
        this.$message.info(this.$t('Message.PayablesIsNull'))
        return
      }
      this.copyCount = 0
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.getBranchIdForCharge())
      this.copyedChargeList = []
      for (const charge of sellings) {
        // CARGO-2399，抄录应付/应收：只抄录普通费用
        if (this.privilege.enableCommission && charge.special) {
          continue
        }
        if (this.checkChargeItemId(charge, true)) {
          await this.realCopySellingHandler(charge, localCurrency, overseaCostDetails)
        }
      }
      if (this.copyCount > 0) {
        this.$message.info(this.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems1') + ' ' + this.copyCount + ' ' + this.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems2'))
      } else {
        this.$message.info(this.$t('Message.NoPayablesCanBeCopiedThereMayBeSameChargeItems'))
      }
      await this.refreshCopyedChargeTitle()
      // 按费用序号排序【需要升序】
      this.tabCost.grid.overseaCostDetails = sortByMultiField(overseaCostDetails, ['serialNumber'], false)
      this.refDgChargeInfo()
    },
    async copyChooseSellingHandler() {
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.getBranchIdForCharge())
      const overseaCostDetails = this.tabCost.grid.overseaCostDetails
      for (const charge of this.chooseSellingRows) {
        await this.realCopySellingHandler(charge, localCurrency, overseaCostDetails)
      }
      this.$message.info(this.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems1') + ' ' + this.chooseSellingRows.length + ' ' + this.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems2'))
      await this.refreshCopyedChargeTitle()
      // 按费用序号排序【需要升序】
      this.tabCost.grid.overseaCostDetails = sortByMultiField(overseaCostDetails, ['serialNumber'], false)
      this.refDgChargeInfo()
    },
    async realCopySellingHandler(charge, localCurrency, overseaCostDetails) {
      const obj = new Charge().fillDefaultValue().getData()
      obj.uuid = this.tabCost.grid.uuidPrefixRule + getUuid()
      obj.jobUuid = this.job.uuid
      obj.chargeItemId = charge.chargeItemId
      if (this.isSpecialExpenseEntryFunction) {
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (chargeItem && chargeItem.specialExpenseMarker) {
          obj.chargeItemId = 0
        }
      }
      obj.inputBy = this.$store.getters.userId
      obj.inputDate = DateUtils.formatStandardDateTime(new Date())
      obj.currency = charge.currency
      obj.measure = charge.measure
      obj.receivable = true
      obj.quantity = charge.quantity
      obj.localCurrency = localCurrency
      obj.unitRate = charge.unitRate
      obj.amount = charge.amount
      obj.taxRate = charge.taxRate
      obj.taxAmount = charge.taxAmount
      obj.excludingTaxAmount = charge.excludingTaxAmount
      obj.verifiedAmount = 0
      obj.accountingDate = null
      obj.counterPartyBillingNo = null
      obj.chargeSource = this.chargeSource
      obj.serialNumber = this.getMaxSerialNumber(obj.receivable) + 1 // 序号，CARGO-5881，按照录入顺序排序
      if (this.config.openHecConfig) {
        obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
      }
      // 后端的  syncBranchId 在前端此处赋值即可
      obj.branchId = this.privilege.showOtherBranchCharge ? this.currentSettleBranchId : this.job.opOffice
      obj.inputByDep = this.job.opDepartment
      obj.businessDate = this.job.businessDate
      obj.estimation = charge.estimation
      if (obj.estimation) {
        obj.estimationAmount = obj.amount
      }
      this.fillDefaultCopyValueByCharge(obj, charge, this.job, true)
      if (this.arSettlementUnitOptional && charge.receivable && !ChargeUtils.checkFactorySign(this.companyFactorySigns, obj.accountId)) {
        obj.accountId = 0
      }
      await ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
      //
      if (obj.accountId && obj.accountId > 0) {
        await this.getSettlementByCompanyId(obj)
      }
      this.copyCount++
      this.copyedChargeList.push(obj)
      if (this.tabCost.grid.overseaCostDetails.findIndex(item => obj.uuid === item.uuid) === -1) {
        this.tabCost.grid.overseaCostDetails.push(obj)
      }
    },
    // 更新费用抬头【多票费用】
    async refreshCopyedChargeTitle(charges = null) {
      const copyedChargeList = charges || this.copyedChargeList
      if (copyedChargeList != null && copyedChargeList.length > 0) {
        await ChargeUtils.updateDefaultInvoiceTitle(copyedChargeList)
      }
    },
    /**
     * 获取费用结算公司
     */
    getBranchIdForCharge() {
      return (this.config.currentOfficeCharge && this.job.salesOffice) ? this.job.salesOffice : this.job.opOffice
    },
    // 是否存在相同的费用名称  isAr: true- 应收费用(抄录应付),false-应付费用(抄录应收)
    checkChargeItemId(charge, isAr) {
      let charges = null
      if (isAr) {
        charges = this.tabCost.grid.overseaCostDetails
      } else {
        charges = this.tabSelling.grid.overseaSellingDetails
      }
      for (const c of charges) {
        if (Number(c.chargeItemId) === Number(charge.chargeItemId) && c.currency === charge.currency && c.measure === charge.measure) {
          return false
        }
      }
      return true
    },
    /**
     * 获取应收/应付费用最大序号
     * @param isAr
     * @returns {number}
     */
    getMaxSerialNumber(isAr = true) {
      let max = 0
      const job = this.job
      if (job.charges && job.charges.length > 0) {
        for (const c of job.charges) {
          if (RateUtil.useOrderCenterMode() && c.branchId !== this.currentSettleBranchId) {
            continue
          }
          if (isAr === c.receivable) {
            if (c.serialNumber > max) {
              max = c.serialNumber
            }
          }
        }
      }
      return max
    },
    // 复制时填充默认对象
    fillDefaultCopyValueByCharge(targetCharge, sourceCharge, job, isArTarget) {
      let chargeItem = null
      if (Number(sourceCharge.chargeItemId) !== 0) {
        chargeItem = ChargeItem.getChargeItemById(sourceCharge.chargeItemId)
      }
      if (chargeItem != null && isArTarget && chargeItem.defaultArCode != null && chargeItem.defaultArCode !== '') {
        targetCharge.accountId = ChargeUtils.getChargeDefaultChargeItem(job, chargeItem.defaultArCode)
      } else if (chargeItem != null && !isArTarget && chargeItem.defaultApCode != null && chargeItem.defaultApCode !== '') {
        targetCharge.accountId = ChargeUtils.getChargeDefaultChargeItem(job, chargeItem.defaultApCode)
      } else {
        targetCharge.accountId = job.customerId
      }
    },
    // 根据结算对象，获取结算代理
    async getSettlementByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
      if (!chargeAccount) {
        return
      }
      if (this.currentViewCacheData.customerSettlementAgentMap.has(accountId)) {
        const staticOptions = this.currentViewCacheData.customerSettlementAgentMap.get(accountId)
        const index = staticOptions.findIndex(p => p.uuid === chargeAccount.uuid)
        if (index < 0) {
          if (chargeAccount) {
            staticOptions.push(chargeAccount)
          }
          this.currentViewCacheData.customerSettlementAgentMap.set(accountId, staticOptions)
        }
        charge.settlementAgentId = staticOptions[0].cmpIdx
      } else {
        const res = await getSettlementAgentsByCmpIdx(charge.accountId)
        let dbSettlementAgents = res.data
        if (!dbSettlementAgents) dbSettlementAgents = []
        if (chargeAccount) {
          const index = dbSettlementAgents.findIndex(p => p.uuid === chargeAccount.uuid)
          if (index < 0) {
            dbSettlementAgents.push(chargeAccount)
          }
        }
        charge.settlementAgentId = dbSettlementAgents[0].cmpIdx
        this.currentViewCacheData.customerSettlementAgentMap.set(accountId, dbSettlementAgents)
      }
    },
    getInvoiceTitleList(accountId) {
      if (this.currentViewCacheData.customerTitlesMap.get(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId).reduce((res, item) => {
          if (!res.find(re => re.invoiceTitle === item.invoiceTitle && re.taxAccount === item.taxAccount)) {
            res.push(item)
          }
          return res
        }, [])
      }
      return []
    }

  }
}
</script>
<style lang="scss">
.change-charge-window {
  label {
    font-size: 12px;
    font-weight: normal;
  }

  .el-select {
    width: 100%;
  }
}
</style>
